import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import ImageList from '@material-ui/core/ImageList';
import DraggableImage from './DraggableImage';

const styles = () => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'auto',
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
});

class ImageGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImageIndex: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { scrollY, onItemClickHandler, data, isOpened } = this.props;
    const { currentImageIndex } = this.state;
    const isChanging = !!(
      scrollY !== prevProps.scrollY ||
      (isOpened && !prevProps.isOpened)
    );
    if (!isOpened && currentImageIndex !== null) {
      this.setState({ currentImageIndex: null });
    } else if (isOpened && this.listElement && isChanging) {
      const lis = this.listElement.getElementsByTagName('li');
      let selectedIndex = null;
      let i = 0;
      for (const li of lis) {
        if (li.offsetTop + li.clientHeight/2 > scrollY) {
          selectedIndex = i;
          break;
        }
        i++;
      }
      if (selectedIndex !== null && selectedIndex !== currentImageIndex) {
        this.setState({ currentImageIndex: selectedIndex });
        onItemClickHandler(data[selectedIndex]);
      }
    }
  }

  render() {
    const { data, dragEnabled, onItemClickHandler, cols, classes, dataIndex } =
      this.props;
    const dataUsed = dataIndex > 0 ? data.slice(0, 40 * dataIndex) : data;

    return (
      <div className={classes.root}>
        <ImageList
          gap={10}
          cols={cols}
          className={classes.gridList}
          ref={(c) => {
            this.listElement = c;
          }}
        >
          {dataUsed.map((tile, index) => (
            <DraggableImage
              height={cols === 1 ? 'auto' : '190px'}
              dragEnabled={dragEnabled}
              key={`${tile.title}-${index}`}
              tile={tile}
              name={tile.title}
              onItemClickHandler={onItemClickHandler}
            />
          ))}
        </ImageList>
      </div>
    );
  }
}

export default withStyles(styles)(ImageGrid);
